import { ProductModule } from '@erp/shared-types';
import { useGetModuleConfigs } from './modules';

/** The name users know each ERP integration module's system by. */
const ERP_NAMES: ReadonlyArray<readonly [ProductModule, string]> = [
  [ProductModule.FAMOUS_INTEGRATION, 'Famous'],
  [ProductModule.ORACLE_EBS_INTEGRATION, 'Oracle EBS'],
  [ProductModule.ORACLE_FUSION_INTEGRATION, 'Oracle Fusion'],
];

/** The ERP's name for an org's enabled modules; "ERP" when none is enabled. */
export function erpNameForModules(
  configs: ReadonlyArray<{ module: ProductModule; enabled: boolean }>,
): string {
  const enabled = new Set(
    configs.flatMap((config) => (config.enabled ? [config.module] : [])),
  );
  return ERP_NAMES.find(([module]) => enabled.has(module))?.[1] ?? 'ERP';
}

/**
 * The name of the organization's ERP (e.g. "Famous"), for labels that say
 * where synced data came from. "ERP" while loading or with no integration.
 */
export function useErpName(): string {
  const { data } = useGetModuleConfigs();
  return erpNameForModules(data ?? []);
}
